/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { v4 } from 'uuid'

// Components
import { Label, Input, CheckBox, TextArea } from 'components/elements'
import Select from 'react-select'
import Content from './shared/Content'
import Loading from './shared/Loading'
import ButtonDefault from './elements/ButtonDefault'

// Third Party

const StyledForm = styled.form`
  position: relative;
`

const ConfirmationMessage = styled(Content)`
  font-size: ${(props) => props.theme.font.size.l};
  text-align: center;
`

// const Label = styled.label`
//   display: block;
// `

const ErrorMessage = styled.p`
  color: red;
  text-align: center;
  width: 100%;
`

const Honeypot = styled.div`
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`

// Spam detection
const MIN_FILL_TIME = 3000

// Random strings like "eCVAcRNTRrRDsgjK": no spaces, mixed case, many capitals
const isRandomString = (value) => {
  if (typeof value !== 'string') return false
  const text = value.trim()
  if (/\s/.test(text) || text.length < 8) return false
  const upper = (text.match(/[A-Z]/g) || []).length
  const lower = (text.match(/[a-z]/g) || []).length
  return upper >= 4 && lower >= 3 && /[a-z][A-Z]/.test(text)
}

// Gmail addresses with many dots like "o.l.o.nig.e.h@gmail.com"
const isDottedGmail = (value) =>
  typeof value === 'string' &&
  /^([^@]*\.){3,}[^@]*@(gmail|googlemail)\.com$/i.test(value.trim())

const URL_REGEX = /(https?:\/\/|www\.|\[url|<a\s)/i

const isSpamSubmission = (fields, formFields) =>
  formFields.some((field) => {
    const value = fields[`input_${field.id}`]
    if (!value || typeof value !== 'string') return false

    switch (field.type) {
      case 'text':
        return isRandomString(value) || URL_REGEX.test(value)
      case 'textarea':
        return (
          isRandomString(value) ||
          (value.trim().length >= 10 && !/\s/.test(value.trim())) ||
          (value.match(/https?:\/\//gi) || []).length > 1
        )
      case 'email':
        return isDottedGmail(value)
      default:
        return false
    }
  })

const Mandatory = styled.span`
  font-size: ${(props) => props.theme.font.size.xm};
  color: ${(props) => props.theme.color.face.contrast};
  margin-left: 5px;
`

const GravityForm = ({ className, id }) => {
  const {
    allGfForm: { edges: gravityData },
  } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(
    ({ node }) => node.formId === id
  )[0]

  const [fields, setFields] = useState({})
  const [form, setForm] = useState(gfForm)
  const [status, setStatus] = useState('')
  const [message, setMessage] = useState('')
  const [honeypot, setHoneypot] = useState('')
  const [mountedAt] = useState(() => Date.now())

  useEffect(() => {
    const tempForm = form

    // add submit button as a field
    if (
      tempForm.formFields.filter((item) => item.type === 'submit').length === 0
    ) {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: 'submit',
          text: tempForm.button.text,
        },
      ]
    }

    setForm({
      ...form,
      ...tempForm,
    })
  }, [])

  async function handleOnSubmit(event) {
    event.preventDefault()

    if (status === 'processing') {
      return
    }

    // Bots: fake a successful submission without sending anything
    if (honeypot || Date.now() - mountedAt < MIN_FILL_TIME) {
      setStatus('done')
      setMessage(form.confirmations?.[0]?.message || '')
      return
    }

    if (isSpamSubmission(fields, form.formFields)) {
      setStatus('spam')
      return
    }

    setStatus('processing')

    try {
      const formData = new FormData()

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value)
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')

        setMessage(response.confirmation_message)
      } else {
        setStatus('error')
        console.log(response)
      }
    } catch (error) {
      setStatus('error')
      console.error(error)
    }
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring
    let { value } = event.target || event.value

    if (event.target) {
      if (event.target.type === 'checkbox') {
        value = event.target.checked ? event.target.value : ''
      }

      setFields({
        ...fields,
        [event.target.name]: value,
      })
    } else {
      setFields({
        ...fields,
        [event.name]: event.value,
      })
    }
  }

  if (status === 'done') {
    return <ConfirmationMessage content={message} />
  }

  if (form.formFields) {
    return (
      <StyledForm
        id={`form_${gfForm.formId}`}
        className={className}
        method="post"
        onSubmit={handleOnSubmit}
      >
        <Honeypot aria-hidden="true">
          <label htmlFor={`website_${gfForm.formId}`}>Website</label>
          <input
            type="text"
            id={`website_${gfForm.formId}`}
            name="website"
            tabIndex="-1"
            autoComplete="off"
            value={honeypot}
            onChange={(e) => setHoneypot(e.target.value)}
          />
        </Honeypot>
        <div className="row">
          {status === 'processing' && <Loading />}
          {status === 'spam' && (
            <ErrorMessage>
              Controleer je invoer. Vul je naam en bericht in gewone tekst in.
            </ErrorMessage>
          )}
          {form.formFields &&
            form.formFields.map((field, key) => {
              if (Array.isArray(field)) {
                return (
                  <div key={key}>
                    {field.map((item, index) => (
                      <>
                        {item.type !== 'submit' ? (
                          <div className="col-lg-6">
                            <FormField
                              key={index}
                              field={item}
                              fields={fields}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={handleFieldChange}
                            />
                          </div>
                        ) : (
                          <div className="col-lg-12 d-flex justify-content-center">
                            <FormField
                              key={index}
                              field={item}
                              fields={fields}
                              onChange={handleFieldChange}
                            />
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                )
              }

              return (
                <>
                  {field.type !== 'submit' ? (
                    <div className="col-lg-6">
                      <FormField
                        field={field}
                        fields={fields}
                        onChange={(e) => handleFieldChange(e)}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-12 d-flex justify-content-center">
                      <FormField
                        field={field}
                        fields={fields}
                        onChange={handleFieldChange}
                      />
                    </div>
                  )}
                </>
              )
            })}
        </div>
      </StyledForm>
    )
  }

  console.error('No gravity forms found with id', id)
  return false
}

const TextField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <div className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <div className="d-flex align-items-center">
        <Label htmlFor={`input_${id}`} text={label}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      </div>
    )}
    <Input
      value={value}
      onChange={onChange}
      type="text"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </div>
)

const EmailField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <div className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <div className="d-flex align-items-center">
        <Label htmlFor={`input_${id}`} text={label}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      </div>
    )}
    <Input
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </div>
)

const PhoneField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <div className="form-group" style={{ marginTop: '-4.7rem' }}>
    {labelPlacement !== 'hidden_label' && (
      <div className="d-flex align-items-center">
        <Label htmlFor={`input_${id}`} text={label}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      </div>
    )}
    <Input
      value={value}
      onChange={onChange}
      type="tel"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </div>
)

const TextAreaField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <div className="form-group pb-5 pb-lg-0">
    {labelPlacement !== 'hidden_label' && (
      <div className="d-flex align-items-center">
        <Label htmlFor={`input_${id}`} text={label}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      </div>
    )}
    <TextArea
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </div>
)

const CheckboxField = ({
  value,
  onChange,
  field: { id, type, cssClass, choices, label, labelPlacement, isRequired },
}) => {
  const list = JSON.parse(choices)

  return (
    <div className="form-group">
      <>
        {labelPlacement !== 'hidden_label' && (
          <div className="d-flex align-items-center">
            <Label htmlFor={`input_${id}`} text={label}>
              {label}
              {isRequired && <Mandatory>*</Mandatory>}
            </Label>
          </div>
        )}
      </>

      {list.map((checkbox, key) => (
        <div
          key={key}
          className="form-group__checkboxes d-flex align-items-center"
        >
          <CheckBox
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label
            htmlFor={`input_${id}_${key + 1}`}
            className="checkbox-content"
          >
            {checkbox.text}
          </label>
        </div>
      ))}
    </div>
  )
}

const StyledSelect = styled.div``

// Select or Dropdown
const SelectField = ({ field, onChange, value }) => {
  // Populate a options array
  const options = []
  JSON.parse(field.choices).forEach((choice) => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`,
    })
  })

  // Custom Select component
  const MySelect = (props) => (
    <Select
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <StyledSelect>
      <MySelect
        options={options}
        onChange={onChange}
        value={options.filter((option) => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
      />
    </StyledSelect>
  )
}

const SubmitButton = ({ field }) => (
  <div>
    <ButtonDefault isCustom>
      <button type="submit" className="text-white font-weight-bold">
        {field.text}
      </button>
    </ButtonDefault>
  </div>
)

const FileField = ({
  value,
  onChange,
  field: { id, type, label, allowedExtensions, cssClass, placeholder },
}) => {
  function handleChange(file) {
    onChange({
      target: {
        name: `input_${id}`,
        value: file,
      },
    })
  }

  function handleFileUpload(e) {
    const {
      e: {
        target: { files },
      },
    } = e

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault()
    console.log(e)

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile())
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i])
      }
    }
  }

  return (
    <div
      className="form-upload"
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      <Label htmlFor={`input_${id}`}>{value ? value.name : <>{label}</>}</Label>
      <input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </div>
  )
}

export const FormField = ({ field, fields, onChange }) => (
  <>
    {field.type === 'text' && (
      <TextField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'email' && (
      <EmailField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'phone' && (
      <PhoneField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'textarea' && (
      <TextAreaField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'checkbox' && (
      <CheckboxField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'select' && (
      <SelectField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'fileupload' && (
      <FileField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'submit' && <SubmitButton field={field} />}
  </>
)

export default GravityForm
